<template>
  <div>
    <div class="card-body">
      <div class="tab-content">
        <div class="p-10">
          <b-table-simple hover small caption-top responsive bordered>
            <template #table-busy>
              <div class="my-2 text-center">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <caption></caption>
            <colgroup>
              <col />
              <col />
            </colgroup>
            <colgroup>
              <col />
              <col />
              <col />
            </colgroup>
            <colgroup>
              <col />
              <col />
            </colgroup>
            <b-thead class="color-table">
              <b-tr>
                <b-th colspan="1" rowspan="2">Loại giao dịch</b-th>
                <b-th
                  colspan="2 "
                  v-for="typeMc in tableListGeneral"
                  :key="typeMc.id"
                  class="text-center"
                  >{{ typeMc.label }}</b-th
                >
              </b-tr>
              <b-tr>
                <template v-for="typeMc in tableListGeneral">
                  <b-th class="text-center table-th-width">TPV</b-th>
                  <b-th class="text-center table-th-width">TPV KPI</b-th>
                </template>
              </b-tr>
            </b-thead>
            <!-- <b-tbody v-if="!isLoading && Object.keys(list).length > 0"> -->
            <b-tbody v-if="!isLoading">
              <b-tr>
                <b-th rowspan="6">
                  <template v-for="transaction in displayTransactionType">
                    <span
                      style="margin-left: 20px"
                      v-if="
                        transaction.hasOwnProperty('parent') &&
                        !transaction.hasOwnProperty('parent_sub1')
                      "
                      ><b-icon icon="arrow-left-right" aria-hidden="true"></b-icon
                      ><span class="ml-2">{{ transaction.text }}</span></span
                    >
                    <span
                      class="text-muted"
                      style="margin-left: 35px"
                      v-if="
                        transaction.hasOwnProperty('parent') &&
                        transaction.hasOwnProperty('parent_sub1')
                      "
                      ><i
                        >•<span class="ml-2">{{ transaction.text }}</span></i
                      ></span
                    >
                    <span class="text-primary" v-if="!transaction.hasOwnProperty('parent')"
                      ><b-icon icon="bar-chart-line" aria-hidden="true" variant="primary"></b-icon
                      ><span class="ml-2">{{ transaction.text }}</span></span
                    >
                    <br />
                  </template>
                </b-th>

                <template v-for="typeMc in tableListGeneral">
                  <template v-if="list[typeMc.id]">
                    <b-td class="text-right">
                      <template v-for="tpv in list[typeMc.id].transactions">
                        <span>{{ tpv.totalTpv | transformMoney }}</span>
                        <br />
                      </template>
                    </b-td>
                    <b-td class="text-right text-success">
                      <template v-for="tpv in list[typeMc.id].transactions">
                        <span>{{ tpv.totalRevenueTpv | transformMoney }}</span>
                        <br />
                      </template>
                    </b-td>
                  </template>
                  <template v-else>
                    <b-td class="text-right">
                      <template v-for="transaction in displayTransactionType">
                        <span>0</span>
                        <br />
                      </template>
                    </b-td>
                    <b-td class="text-right text-success">
                      <template v-for="transaction in displayTransactionType">
                        <span>0</span>
                        <br />
                      </template>
                    </b-td>
                  </template>
                </template>
              </b-tr>
            </b-tbody>
            <!-- <b-tfoot class="color-table" v-if="!isLoading && Object.keys(list).length > 0"> -->
            <b-tfoot class="color-table" v-if="!isLoading">
              <b-tr>
                <b-td colspan="1" class="text-left"> Tổng </b-td>
                <template v-for="typeMc in tableListGeneral">
                  <template>
                    <b-td v-if="list[typeMc.id] && list[typeMc.id].totalTpv" class="text-right">{{
                      list[typeMc.id].totalTpv | transformMoney
                    }}</b-td>
                    <b-td v-else class="text-right">0</b-td>
                    <b-td
                      v-if="list[typeMc.id] && list[typeMc.id].totalRevenueTpv"
                      class="text-right text-success"
                      >{{ list[typeMc.id].totalRevenueTpv | transformMoney }}</b-td
                    >
                    <b-td v-else class="text-right text-success">0</b-td>
                  </template>
                </template>
              </b-tr>
            </b-tfoot>
            <div class="text-center my-2" v-if="isLoading">
              <b-spinner class="align-middle" />
            </div>
            <!-- <div class="text-center text-info my-2" v-if="!isLoading && Object.keys(list).length === 0">
              Không có dữ liệu
            </div> -->
          </b-table-simple>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { filterMcTpvTxSummary } from '@/services/customer-support/tpv'

  export default {
    data() {
      return {
        isLoading: true,
        optionTransactionType: [
          { id: 'MANUAL_PAYMENT', text: 'Thanh toán có hiện diện' },
          { id: 'ONLINE_PAYMENT', text: 'Thanh toán không hiện diện' },
          { id: 'INSTALLMENT', text: 'Thanh toán trả góp' },
          { id: 'BNPL', text: 'BNPL' },
          { id: 'MOTO', text: 'MOTO' },
          { id: 'LENDING_NEXTLEND', text: 'Nextlend' },
          { id: 'OTHER', text: 'Other' },
        ],
        list: {},
        search: {},
        tableListGeneral: [
          { id: 'NEW_MC', label: 'MC mới' },
          { id: 'OLD_MC_NEW_BRANCH', label: 'MC cũ CN mới' },
          { id: 'OLD_MC_REACTIVATED', label: 'MC cũ kích hoạt lại' },
          { id: 'OTHER', label: 'MC không tính KPI' },
          { id: 'TOTAL_TRANSACTION', label: 'Tổng TPV theo loại giao dịch' },
        ],
        displayTransactionType: [
          { id: 'MANUAL_PAYMENT', text: 'Thanh toán có hiện diện' },
          { id: 'MANUAL_PAYMENT_BANK', text: 'Thanh toán thẻ', parent: 'MANUAL_PAYMENT' },
          { id: 'MANUAL_PAYMENT_NFC', text: 'Thanh toán NFC', parent: 'MANUAL_PAYMENT' },
          {
            id: 'MANUAL_PAYMENT_NFC_AGS',
            text: 'NFC qua AGS',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_NFC',
          },
          {
            id: 'MANUAL_PAYMENT_NFC_BANK',
            text: 'NFC bằng thẻ',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_NFC',
          },
          { id: 'MANUAL_PAYMENT_QR', text: 'QR code', parent: 'MANUAL_PAYMENT' },
          {
            id: 'MANUAL_PAYMENT_QR_VIETQR',
            text: 'VIETQR',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          {
            id: 'MANUAL_PAYMENT_QR_CREDIT',
            text: 'QR thẻ tín dụng',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          {
            id: 'MANUAL_PAYMENT_QR_OTHER',
            text: 'QR khác',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          { id: 'ONLINE_PAYMENT', text: 'Thanh toán không hiện diện' },
          { id: 'ONLINE_PAYMENT_BANK', text: 'Thanh toán thẻ', parent: 'ONLINE_PAYMENT' },
          { id: 'ONLINE_PAYMENT_NFC', text: 'Thanh toán NFC', parent: 'ONLINE_PAYMENT' },
          { id: 'ONLINE_PAYMENT_QR', text: 'Qr code/khác', parent: 'ONLINE_PAYMENT' },
          { id: 'ONLINE_PAYMENT_PAYON', text: 'Tích hợp Payon', parent: 'ONLINE_PAYMENT' },
          { id: 'INSTALLMENT', text: 'Trả góp' },
          { id: 'BNPL', text: 'BNPL' },
          { id: 'MOTO', text: 'MOTO' },
          { id: 'LENDING_NEXTLEND', text: 'Nextlend' },
          { id: 'OTHER', text: 'OTHER' },
        ],
        transactionTypeGeneral: [
          { id: 'MANUAL_PAYMENT', text: 'Thanh toán thường có hiện diện' },
          { id: 'ONLINE_PAYMENT', text: 'Thanh toán thường không hiện diện' },
          { id: 'INSTALLMENT', text: 'Thanh toán trả góp' },
          { id: 'BNPL', text: 'Buy now pay later' },
          { id: 'MOTO', text: 'Giao dịch moto' },
          { id: 'LENDING_NEXTLEND', text: 'Khoản vay lending' },
          { id: 'OTHER', text: 'Giao dịch khác' },
        ],
        logicMapDataDisplay: [
          {
            id: 'MANUAL_PAYMENT',
            text: 'Thanh toán thường có hiện diện',
            parent: 'MANUAL_PAYMENT',
          },
          {
            id: 'MANUAL_PAYMENT_BANK',
            text: 'Thanh toán thường có hiện diện qua bank',
            parent: 'MANUAL_PAYMENT',
          },
          {
            id: 'MANUAL_PAYMENT_NFC',
            text: 'Thanh toán thường có hiện diện qua NFC',
            parent: 'MANUAL_PAYMENT',
          },
          {
            id: 'MANUAL_PAYMENT_NFC_AGS',
            text: 'Thanh toán thường có hiện diện qua NFC bằng AGS',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_NFC',
          },
          {
            id: 'MANUAL_PAYMENT_NFC_BANK',
            text: 'Thanh toán thường có hiện diện qua NFC bằng thẻ ngân hàng',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_NFC',
          },
          {
            id: 'MANUAL_PAYMENT_QR',
            text: 'Thanh toán thường có hiện diện qua QR',
            parent: 'MANUAL_PAYMENT',
          },
          {
            id: 'MANUAL_PAYMENT_QR_VIETQR',
            text: 'Thanh toán thường có hiện diện qua QR VIETQR',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          {
            id: 'MANUAL_PAYMENT_QR_CREDIT',
            text: 'Thanh toán thường có hiện diện qua QR bằng thẻ tín dụng',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          {
            id: 'MANUAL_PAYMENT_QR_OTHER',
            text: 'Thanh toán thường có hiện diện qua QR khác',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          {
            id: 'ONLINE_PAYMENT',
            text: 'Thanh toán thường không hiện diện',
            parent: 'ONLINE_PAYMENT',
          },
          {
            id: 'ONLINE_PAYMENT_BANK',
            text: 'Thanh toán thường không hiện diện qua bank',
            parent: 'ONLINE_PAYMENT',
          },
          {
            id: 'ONLINE_PAYMENT_NFC',
            text: 'Thanh toán thường không hiện diện qua NFC',
            parent: 'ONLINE_PAYMENT',
          },
          {
            id: 'ONLINE_PAYMENT_QR',
            text: 'Thanh toán thường không hiện diện qua QR',
            parent: 'ONLINE_PAYMENT',
          },
          {
            id: 'ONLINE_PAYMENT_PAYON',
            text: 'Thanh toán online tích hợp payon ',
            parent: 'ONLINE_PAYMENT',
          },
          { id: 'INSTALLMENT', text: 'Thanh toán trả góp' },
          { id: 'BNPL', text: 'Buy now pay later' },
          { id: 'MOTO', text: 'Giao dịch moto' },
          { id: 'LENDING_NEXTLEND', text: 'Khoản vay lending' },
          { id: 'OTHER', text: 'Giao dịch khác' },
        ],
      }
    },
    computed: {
      joinArrayDataTransaction() {
        return (item, option = 'id', key = 'text') => {
          const mapData = this.displayTransactionType.find(e => e[option] === item)
          return mapData ? mapData[key] : ''
        }
      },
    },
    methods: {
      async fetchData() {
        try {
          this.isLoading = true
          const res = await filterMcTpvTxSummary(this.search)
          if (res.code === 1000 && res.data) {
            const mapData = res.data.tpvMcSummary ?? []
            this.prepareDisplayData(mapData)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.isLoading = false
        }
      },
      // show(dataSearch) {
      //   this.search = {
      //     ...dataSearch,
      //   };
      //   this.fetchData();
      // },
      loadData(filter) {
        this.search = filter
        this.fetchData()
      },
      prepareDisplayData(data) {
        const totalTransaction = {}
        const order = this.transactionTypeGeneral.map(option => option.id)
        const transactionType = []

        this.list = data.reduce((acc, current) => {
          if (!acc[current.typeMc]) {
            acc[current.typeMc] = {
              transactions: [],
              totalTpv: 0,
              totalRevenueTpv: 0,
            }
          }

          acc[current.typeMc].transactions.push(current)
          acc[current.typeMc].totalTpv += current.totalTpv
          acc[current.typeMc].totalRevenueTpv += current.totalRevenueTpv

          if (!totalTransaction[current.subTypeTransaction2]) {
            totalTransaction[current.subTypeTransaction2] = {
              totalTpv: 0,
              totalRevenueTpv: 0,
              typeTransaction: '',
              subTypeTransaction1: '',
              subTypeTransaction2: '',
            }
            transactionType.push(current.subTypeTransaction2)
          }

          totalTransaction[current.subTypeTransaction2].totalTpv += current.totalTpv
          totalTransaction[current.subTypeTransaction2].totalRevenueTpv += current.totalRevenueTpv
          totalTransaction[current.subTypeTransaction2].typeTransaction = current.typeTransaction
          totalTransaction[current.subTypeTransaction2].subTypeTransaction1 =
            current.subTypeTransaction1
          totalTransaction[current.subTypeTransaction2].subTypeTransaction2 =
            current.subTypeTransaction2

          return acc
        }, {})

        if (Object.keys(totalTransaction).length > 0) {
          this.list.TOTAL_TRANSACTION = {
            transactions: [],
            totalTpv: 0,
            totalRevenueTpv: 0,
          }

          for (const key in totalTransaction) {
            this.list.TOTAL_TRANSACTION.transactions.push(totalTransaction[key])
            this.list.TOTAL_TRANSACTION.totalTpv += totalTransaction[key].totalTpv
            this.list.TOTAL_TRANSACTION.totalRevenueTpv += totalTransaction[key].totalRevenueTpv
          }
        }

        const manualPayment = this.logicMapDataDisplay.filter(
          e => e.parent === 'MANUAL_PAYMENT' && !e.parent_sub1
        )
        const manualPaymentQr = this.logicMapDataDisplay.filter(
          e => e.parent_sub1 === 'MANUAL_PAYMENT_QR'
        )
        const manualPaymentNfc = this.logicMapDataDisplay.filter(
          e => e.parent_sub1 === 'MANUAL_PAYMENT_NFC'
        )
        const onlinePayment = this.logicMapDataDisplay.filter(e => e.parent === 'ONLINE_PAYMENT')

        for (const key in this.list) {
          // logic check data exist and not exist change data = 0 with data not exist
          const existingTypes = this.list[key].transactions.map(tx => tx.typeTransaction)
          for (let i = 0; i < order.length; i++) {
            if (existingTypes.includes(order[i])) {
              const checkOnlinePayment = this.list[key].transactions.filter(
                s => s.typeTransaction === 'ONLINE_PAYMENT'
              )
              if (checkOnlinePayment.length < onlinePayment.length) {
                const existingOnlinePayment = checkOnlinePayment.map(tx => tx.subTypeTransaction1)

                for (let j = 0; j < onlinePayment.length; j++) {
                  if (!existingOnlinePayment.includes(onlinePayment[j].id)) {
                    this.list[key].transactions.push({
                      typeMc: key,
                      typeTransaction: onlinePayment[j].parent,
                      subTypeTransaction1: onlinePayment[j].id,
                      subTypeTransaction2: onlinePayment[j].id,
                      totalTpv: 0,
                      totalRevenueTpv: 0,
                      totalTransaction: 0,
                    })
                  }
                }
              }

              const manualPaymentQrCurrent = this.list[key].transactions.filter(
                s => s.subTypeTransaction1 === 'MANUAL_PAYMENT_QR'
              )
              const manualPaymentNfcCurrent = this.list[key].transactions.filter(
                s => s.subTypeTransaction1 === 'MANUAL_PAYMENT_NFC'
              )
              const manualPaymentCurrent = this.list[key].transactions.filter(
                s =>
                  s.typeTransaction === 'MANUAL_PAYMENT' &&
                  s.subTypeTransaction1 !== 'MANUAL_PAYMENT_QR' &&
                  s.subTypeTransaction1 !== 'MANUAL_PAYMENT_NFC'
              )

              if (manualPaymentQrCurrent.length < manualPaymentQr.length) {
                const existingManualPaymentQr = manualPaymentQrCurrent.map(
                  tx => tx.subTypeTransaction2
                )
                for (let j = 0; j < manualPaymentQr.length; j++) {
                  if (!existingManualPaymentQr.includes(manualPaymentQr[j].id) && order[i]) {
                    this.list[key].transactions.push({
                      typeMc: key,
                      typeTransaction: manualPaymentQr[j].parent,
                      subTypeTransaction1: manualPaymentQr[j].parent_sub1,
                      subTypeTransaction2: manualPaymentQr[j].id,
                      totalTpv: 0,
                      totalRevenueTpv: 0,
                      totalTransaction: 0,
                    })
                  }
                }
              }

              if (manualPaymentNfcCurrent.length < manualPaymentNfc.length) {
                const existingManualPaymentNfc = manualPaymentNfcCurrent.map(
                  tx => tx.subTypeTransaction2
                )
                for (let j = 0; j < manualPaymentNfc.length; j++) {
                  if (!existingManualPaymentNfc.includes(manualPaymentNfc[j].id)) {
                    this.list[key].transactions.push({
                      typeMc: key,
                      typeTransaction: manualPaymentNfc[j].parent,
                      subTypeTransaction1: manualPaymentNfc[j].parent_sub1,
                      subTypeTransaction2: manualPaymentNfc[j].id,
                      totalTpv: 0,
                      totalRevenueTpv: 0,
                      totalTransaction: 0,
                    })
                  }
                }
              }

              if (manualPaymentCurrent.length < manualPayment.length) {
                const existingManualPayment = manualPaymentCurrent.map(tx => tx.subTypeTransaction2)
                for (let j = 0; j < manualPayment.length; j++) {
                  if (!existingManualPayment.includes(manualPayment[j].id)) {
                    this.list[key].transactions.push({
                      typeMc: key,
                      typeTransaction: manualPayment[j].parent,
                      subTypeTransaction1: manualPayment[j].parent,
                      subTypeTransaction2: manualPayment[j].id,
                      totalTpv: 0,
                      totalRevenueTpv: 0,
                      totalTransaction: 0,
                    })
                  }
                }
              }
            }
            if (!existingTypes.includes(order[i])) {
              if (order[i] === 'ONLINE_PAYMENT') {
                const checkOnlinePayment = this.list[key].transactions.filter(
                  s => s.typeTransaction === 'ONLINE_PAYMENT'
                )
                if (checkOnlinePayment.length < onlinePayment.length) {
                  for (let j = 0; j < onlinePayment.length; j++) {
                    this.list[key].transactions.push({
                      typeMc: key,
                      typeTransaction: order[i],
                      subTypeTransaction1: onlinePayment[j].id,
                      subTypeTransaction2: onlinePayment[j].id,
                      totalTpv: 0,
                      totalRevenueTpv: 0,
                      totalTransaction: 0,
                    })
                  }
                }
              } else if (order[i] === 'MANUAL_PAYMENT') {
                for (let j = 0; j < manualPayment.length; j++) {
                  if (manualPayment[j].parent_sub1 === 'MANUAL_PAYMENT_QR') {
                    const manualPaymentQrCurrent = this.list[key].transactions.filter(
                      s => s.subTypeTransaction1 === 'MANUAL_PAYMENT_QR'
                    )

                    if (manualPaymentQrCurrent.length < manualPaymentQr.length) {
                      for (let k = 0; k < manualPaymentQr.length; k++) {
                        this.list[key].transactions.push({
                          typeMc: key,
                          typeTransaction: order[i],
                          subTypeTransaction1: manualPayment[j].id,
                          subTypeTransaction2: manualPaymentQr[k].id,
                          totalTpv: 0,
                          totalRevenueTpv: 0,
                          totalTransaction: 0,
                        })
                      }
                    }
                  }
                  if (manualPayment[j].parent_sub1 === 'MANUAL_PAYMENT_NFC') {
                    const manualPaymentNfcCurrent = this.list[key].transactions.filter(
                      s => s.subTypeTransaction1 === 'MANUAL_PAYMENT_NFC'
                    )

                    if (manualPaymentNfcCurrent.length < manualPaymentNfc.length) {
                      for (let k = 0; k < manualPaymentNfc.length; k++) {
                        this.list[key].transactions.push({
                          typeMc: key,
                          typeTransaction: order[i],
                          subTypeTransaction1: manualPayment[j].id,
                          subTypeTransaction2: manualPaymentNfc[k].id,
                          totalTpv: 0,
                          totalRevenueTpv: 0,
                          totalTransaction: 0,
                        })
                      }
                    }
                  }
                  if (!manualPayment[j].parent_sub1) {
                    const existManual = this.list[key].transactions.map(s => s.subTypeTransaction2)
                    if (!existManual.includes(manualPayment[j].id)) {
                      this.list[key].transactions.push({
                        typeMc: key,
                        typeTransaction: order[i],
                        subTypeTransaction1: manualPayment[j].id,
                        subTypeTransaction2: manualPayment[j].id,
                        totalTpv: 0,
                        totalRevenueTpv: 0,
                        totalTransaction: 0,
                      })
                    }
                  }
                }
              } else {
                const existingNormal = this.list[key].transactions.map(tx => tx.subTypeTransaction2)
                const normal = this.logicMapDataDisplay.filter(e => !e.parent)

                for (let j = 0; j < normal.length; j++) {
                  if (!existingNormal.includes(normal[j].id)) {
                    this.list[key].transactions.push({
                      typeMc: key,
                      typeTransaction: normal[j].id,
                      subTypeTransaction1: normal[j].id,
                      subTypeTransaction2: normal[j].id,
                      totalTpv: 0,
                      totalRevenueTpv: 0,
                      totalTransaction: 0,
                    })
                  }
                }
              }
            }
          }

          // sort following key id location
          this.list[key].transactions = this.sortArray2BasedOnArray1(
            this.logicMapDataDisplay,
            this.list[key].transactions
          )

          if (this.list[key].transactions.length > this.logicMapDataDisplay.length) {
            this.list[key].transactions = this.list[key].transactions.filter(
              (obj, index, self) =>
                index === self.findIndex(t => t.subTypeTransaction2 === obj.subTypeTransaction2)
            )
          }

          // total transaction following group
          const totalPaymentOnline = { totalTpv: 0, totalRevenueTpv: 0 }
          const totalPaymentManual = { totalTpv: 0, totalRevenueTpv: 0 }
          const totalPaymentManualQR = { totalTpv: 0, totalRevenueTpv: 0 }
          const totalPaymentManualNFC = { totalTpv: 0, totalRevenueTpv: 0 }

          for (let j = 0; j < this.list[key].transactions.length; j++) {
            if (this.list[key].transactions[j].typeTransaction === 'ONLINE_PAYMENT') {
              totalPaymentOnline.totalTpv += this.list[key].transactions[j].totalTpv
              totalPaymentOnline.totalRevenueTpv += this.list[key].transactions[j].totalRevenueTpv
            }
            if (this.list[key].transactions[j].subTypeTransaction1 === 'MANUAL_PAYMENT_QR') {
              totalPaymentManualQR.totalTpv += this.list[key].transactions[j].totalTpv
              totalPaymentManualQR.totalRevenueTpv += this.list[key].transactions[j].totalRevenueTpv
            }
            if (this.list[key].transactions[j].subTypeTransaction1 === 'MANUAL_PAYMENT_NFC') {
              totalPaymentManualNFC.totalTpv += this.list[key].transactions[j].totalTpv
              totalPaymentManualNFC.totalRevenueTpv +=
                this.list[key].transactions[j].totalRevenueTpv
            }
            if (
              this.list[key].transactions[j].typeTransaction === 'MANUAL_PAYMENT' &&
              this.list[key].transactions[j].subTypeTransaction1 !== 'MANUAL_PAYMENT_QR' &&
              this.list[key].transactions[j].subTypeTransaction1 !== 'MANUAL_PAYMENT_NFC'
            ) {
              totalPaymentManual.totalTpv += this.list[key].transactions[j].totalTpv
              totalPaymentManual.totalRevenueTpv += this.list[key].transactions[j].totalRevenueTpv
            }
          }

          const indexPaymentOnline = this.list[key].transactions.findIndex(
            item => item.subTypeTransaction2 === 'ONLINE_PAYMENT'
          )
          if (indexPaymentOnline !== -1) {
            this.$set(this.list[key].transactions, indexPaymentOnline, {
              ...this.list[key].transactions[indexPaymentOnline],
              totalTpv: totalPaymentOnline.totalTpv,
              totalRevenueTpv: totalPaymentOnline.totalRevenueTpv,
            })
          }
          const indexPaymentManualQr = this.list[key].transactions.findIndex(
            item => item.subTypeTransaction2 === 'MANUAL_PAYMENT_QR'
          )
          if (indexPaymentManualQr !== -1) {
            this.$set(this.list[key].transactions, indexPaymentManualQr, {
              ...this.list[key].transactions[indexPaymentManualQr],
              totalTpv: totalPaymentManualQR.totalTpv,
              totalRevenueTpv: totalPaymentManualQR.totalRevenueTpv,
            })
          }
          const indexPaymentManualNfc = this.list[key].transactions.findIndex(
            item => item.subTypeTransaction2 === 'MANUAL_PAYMENT_NFC'
          )
          if (indexPaymentManualNfc !== -1) {
            this.$set(this.list[key].transactions, indexPaymentManualNfc, {
              ...this.list[key].transactions[indexPaymentManualNfc],
              totalTpv: totalPaymentManualNFC.totalTpv,
              totalRevenueTpv: totalPaymentManualNFC.totalRevenueTpv,
            })
          }
          const indexPaymentManual = this.list[key].transactions.findIndex(
            item => item.subTypeTransaction2 === 'MANUAL_PAYMENT'
          )
          if (indexPaymentManual !== -1) {
            this.$set(this.list[key].transactions, indexPaymentManual, {
              ...this.list[key].transactions[indexPaymentManual],
              totalTpv:
                totalPaymentManual.totalTpv +
                totalPaymentManualQR.totalTpv +
                totalPaymentManualNFC.totalTpv,
              totalRevenueTpv:
                totalPaymentManual.totalRevenueTpv +
                totalPaymentManualQR.totalRevenueTpv +
                totalPaymentManualNFC.totalRevenueTpv,
            })
          }
        }
      },
      changeTable(table) {
        this.tableListGeneral = table
      },
      sortArray2BasedOnArray1(array1, array2) {
        // Tạo một map từ id đến index trong mảng 1
        const idToIndexMap = new Map(array1.map((item, index) => [item.id, index]))

        // Hàm so sánh tùy chỉnh
        function customCompare(a, b) {
          const indexA = idToIndexMap.get(a.subTypeTransaction2) ?? Infinity
          const indexB = idToIndexMap.get(b.subTypeTransaction2) ?? Infinity
          return indexA - indexB
        }

        // Sắp xếp mảng 2
        return array2.sort(customCompare)
      },
    },
  }
</script>
<style scoped>
  .color-table {
    color: #212529;
    background-color: rgba(0, 0, 0, 0.03);
  }

  .table-th-width {
    min-width: 100px;
    max-width: 100px;
  }
</style>
